"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _resize = _interopRequireDefault(require("../../hocs/resize"));
var _InstrumentRow = _interopRequireDefault(require("../../components/InstrumentRow"));
var _OrderBookContainer = _interopRequireDefault(require("../../components/OrderBookComponents/OrderBookContainer"));
var _PriceChartContainer = _interopRequireDefault(require("../../components/PriceChart/PriceChartContainer"));
var _DepthChartContainer = _interopRequireDefault(require("../../components/DepthChart/DepthChartContainer"));
var _RecentTradesContainer = _interopRequireDefault(require("../../components/RecentTrades/RecentTradesContainer"));
var _OrderEntryContainer = _interopRequireDefault(require("../../components/OrderEntryComponents/defaultForm/OrderEntryContainer"));
var _InstrumentPositionsWrapper = _interopRequireDefault(require("../../components/InstrumentPositionsWrapper"));
var _ConfirmLimitOrderModalContainer = _interopRequireDefault(require("../../components/ConfirmLimitOrderModal/ConfirmLimitOrderModalContainer"));
var _OrderHistoryComponents = _interopRequireDefault(require("../../components/OrderHistoryComponents"));
var _MarginOrderHistory = _interopRequireDefault(require("../../components/OrderHistoryComponents/MarginOrderHistory"));
var _TradingLayoutContent480Px = _interopRequireDefault(require("../Responsive/TrandingLayout/TradingLayoutContent480Px"));
var _TradingLayoutContent1280Px = _interopRequireDefault(require("../Responsive/TrandingLayout/TradingLayoutContent1280Px"));
var _TradingLayoutContent1440Px = _interopRequireDefault(require("../Responsive/TrandingLayout/TradingLayoutContent1440Px"));
var _TradingLayoutCharts1280Px = _interopRequireDefault(require("../Responsive/TrandingLayout/TradingLayoutCharts1280Px"));
var _MarginClosePositionModal = _interopRequireDefault(require("../../components/MarginClosePosition/MarginClosePositionModal"));
var _MarginTransferAssetsModal = _interopRequireDefault(require("../../components/MarginTransferAssetModal/MarginTransferAssetsModal"));
var _config = _interopRequireDefault(require("../../config"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./TradingLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var tradingLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('trading-layout');
var TradingLayout = function TradingLayout(props) {
  var height = props.height,
    width = props.width,
    isMarginEnabledSelector = props.isMarginEnabledSelector;
  var renderActivity = function renderActivity() {
    var config = props.config,
      isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
      maxLines = config.TradingLayout.maxLines;
    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };
    return isMarginActive ? /*#__PURE__*/_react["default"].createElement(_MarginOrderHistory["default"], {
      config: orderHistoryConfig
    }) : /*#__PURE__*/_react["default"].createElement(_OrderHistoryComponents["default"], {
      config: orderHistoryConfig
    });
  };
  if (width > 968 && width <= 1280) {
    return /*#__PURE__*/_react["default"].createElement(_TradingLayoutContent1280Px["default"], _extends({
      "short": height <= 1080,
      OrderBook: _OrderBookContainer["default"],
      OrderEntry: _OrderEntryContainer["default"],
      InstrumentPositions: _InstrumentPositionsWrapper["default"],
      RecentTrades: _RecentTradesContainer["default"]
    }, props));
  }
  if (width > 1280) {
    return /*#__PURE__*/_react["default"].createElement(_TradingLayoutContent1440Px["default"], _extends({
      "short": height <= 1080,
      OrderBook: _OrderBookContainer["default"],
      OrderEntry: _OrderEntryContainer["default"],
      InstrumentPositions: _InstrumentPositionsWrapper["default"],
      RecentTrades: _RecentTradesContainer["default"]
    }, props));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentRow["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('chart-container')
  }, /*#__PURE__*/_react["default"].createElement(_TradingLayoutCharts1280Px["default"], {
    PriceChart: _PriceChartContainer["default"],
    DepthChart: _DepthChartContainer["default"],
    showDepthChart: _config["default"].TradingLayout.showDepthChart
  }), renderActivity()), /*#__PURE__*/_react["default"].createElement(_TradingLayoutContent480Px["default"], {
    OrderBook: _OrderBookContainer["default"],
    OrderEntry: _OrderEntryContainer["default"],
    InstrumentPositions: _InstrumentPositionsWrapper["default"],
    RecentTrades: _RecentTradesContainer["default"]
  })), /*#__PURE__*/_react["default"].createElement(_ConfirmLimitOrderModalContainer["default"], null), isMarginEnabledSelector && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null), /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsModal["default"], null)));
};
var _default = exports["default"] = (0, _resize["default"])(TradingLayout);